import { render, staticRenderFns } from "./tumorsynDetail.vue?vue&type=template&id=13b32ed2&scoped=true"
import script from "./tumorsynDetail.vue?vue&type=script&lang=js"
export * from "./tumorsynDetail.vue?vue&type=script&lang=js"
import style0 from "./tumorsynDetail.vue?vue&type=style&index=0&id=13b32ed2&prod&scoped=true&lang=css"
import style1 from "./tumorsynDetail.vue?vue&type=style&index=1&id=13b32ed2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b32ed2",
  null
  
)

export default component.exports